const sessionStorageKeys = {
  X_AUTH_TOKEN: 'x-auth-token'
};

export default sessionStorageKeys;
